import { useSelector } from 'react-redux';
import { useState, useEffect, useRef, useCallback } from 'react';
import api from 'util/api';
import logger from 'util/logger';
import c from 'util/const';

export const useCardBackupModals = () => {
  const { stage, userMaster } = useSelector(state => state.app);

  // API data state
  const [notificationData, setNotificationData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const hasCalledAPI = useRef(false);
  const hasShownModal = useRef(false);

  // Fetch notifications from API
  const fetchNotifications = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await api.creditcardsNotifications.list();

      // Handle notifications data
      setNotificationData({
        notifications:
          response?.Notifications?.length > 0 ? response?.Notifications[0] : [],
        primaryCard: response?.PrimaryCard || null,
        backupCard: response?.BackupCard || null,
        IsDiscountAvailable: response?.IsDiscountAvailable || false,
        DiscountPercentage: response?.DiscountPercentage || 0
      });
    } catch (err) {
      logger.log('Error loading credit card notifications:', err);
      setError('Failed to load notifications');
    } finally {
      setLoading(false);
    }
  }, []);

  // Only run after all staged post-login calls complete
  useEffect(() => {
    // Only call API when stage is NULL and userMaster exists
    if (stage !== c.stages.NULL) {
      // Reset the flags when stage changes away from NULL
      hasCalledAPI.current = false;
      hasShownModal.current = false;
      return;
    }

    // Prevent multiple API calls for the same stage
    if (hasCalledAPI.current) {
      return;
    }

    hasCalledAPI.current = true;
    fetchNotifications();
  }, [stage, userMaster, fetchNotifications]);

  return {
    notificationData,
    loading,
    error,
    hasShownModal
  };
};

export default useCardBackupModals;
